module.exports = __webpack_public_path__ + "static/img/productpages.c5016b5d.svg";